function PayoutMappingListCtrl(toaster, $state, $auth, $stateParams, PayoutListService, AppSettings, CommonService, ShopifyMappingService, AmazonPayoutService) {
  'ngInject';
  const vm = this;
  vm.loading = false;
  vm.pageNumber = !$stateParams.pageNumber ? 1 : $stateParams.pageNumber;
  vm.payoutListForm = {};
  vm.size = !$stateParams.size ? 50 : $stateParams.size;
  vm.sortBy = !$stateParams.sortBy ? '' : $stateParams.sortBy;
  vm.sortFlag = false;
  vm.importLoading = false;
  vm.searchParams = {
    name: ($stateParams.name ? $stateParams.name : '')
  };
  vm.allOrganizations = [];
  vm.selectedOrganization = {};
  vm.organizationMappings = [];
  vm.selectedMappings = {};
  vm.orgId = $stateParams.orgId;
  vm.editFlag = $stateParams.id && $stateParams.mapping;
  vm.taxTypes = ['tax exclusive', 'tax inclusive', 'no tax'];
  vm.payoutListForm.tax_type = vm.taxTypes[2].split('_').join(' ');

  vm.init = function () {
    vm.url = `/organizations/${$stateParams.orgId}/amazon_payout_mappings.json?page=${vm.pageNumber}&size=${vm.size}&by_mapping=${vm.searchParams.name}&sort=${vm.sortBy}`;
    vm.dataloading = true;
    PayoutListService.getPayoutMappings($stateParams.orgId, vm.url, vm.pageNumber, vm.size, function (response) {
      vm.dataloading = false;
      if (response.status == 200) {
        vm.mappingResponse = response.data;
        vm.currentPage = !vm.mappingResponse.pagination ? 1 : vm.mappingResponse.pagination.current_page;
        vm.totalPages = !vm.mappingResponse.pagination ? 1 : vm.mappingResponse.pagination.total_page;
        vm.mappingList = response.data.amazon_payout_mappings;
        vm.mappingList.forEach(function (d) {
          d.tax_type = d.tax_type.split('_').join(' ');
        });
        vm.getOrganizations('');
      }
    });
  };

  vm.noMappingsAvailable = function () {
    return vm.mappingList && vm.mappingList.length <= 0 && (vm.searchParams.name === '' || vm.searchParams.name === undefined || vm.searchParams.name === null);
  };

  vm.refreshOrganizationList = function (search) {
    PayoutListService.getOrganizations(search, function (data) {
      vm.allOrganizations = data.data.organizations;
    });
  };

  vm.getContacts = function () {
    ShopifyMappingService.getContacts($stateParams.orgId, function (response) {
      vm.contacts = response.data;
      if ($stateParams.mapping) {
        let mappingParams = $stateParams.mapping ? JSON.parse(JSON.stringify($stateParams.mapping)) : {};
        vm.payoutListForm.mapping = mappingParams.mapping;
        vm.payoutListForm.tax_type = mappingParams.tax_type.split('_').join(' ');
        let contact = vm.contacts.find(function (d) {
          return d.id == mappingParams.contact_id;
        });
        vm.payoutListForm.api_v1_contact = JSON.parse(JSON.stringify(contact));
      }
    });
  };

  vm.importMappings = function () {
    if (!vm.selectedOrganization) {
      toaster.pop('error', 'Please Select source organization.');
    } else if (vm.selectedOrganization && vm.selectedOrganization.id == vm.orgId) {
      toaster.pop('error', 'Source organization and target organization are same.');
    } else if (!(vm.selectedMappings && vm.selectedMappings.id)) {
      toaster.pop('error', 'Please Select Mapping.');
    } else {
      vm.importLoading = true;
      PayoutListService.importMappings(vm.selectedOrganization.id, [vm.selectedMappings.id], vm.orgId, function (response) {
        vm.payoutListForm = {};
        vm.importLoading = false;
        if (response.status >= 200 && response.status < 300) {
          vm.init();
          toaster.pop('info', response.data.message);
        } else {
          toaster.pop('error', CommonService.throwError(response));
        }
      });
    }
  };

  vm.selectImportOrganization = function () {
    AmazonPayoutService.getMappings(vm.selectedOrganization.id, function (response) {
      if (response.status == 200 && response.data.mappings.length > 0) {
        vm.organizationMappings = [{ id: -1, mapping: 'All' }, ...response.data.mappings];
      } else {
        vm.organizationMappings = [];
      }
    });
  };

  vm.addNewContact = function () {
    vm.contactLoader = true;
    ShopifyMappingService.addNewContact(vm.addContact, $stateParams.orgId, function (response) {
      vm.contactLoader = false;
      if (response.status >= 200 && response.status < 300) {
        vm.contacts = [response.data.contact].concat(vm.contacts);
        toaster.pop('info', 'New contact added');
      } else {
        toaster.pop('error', CommonService.throwError(response));
      }
    });
  };

  vm.updateTest = function (d, $event) {
    if ($event && $event.type == 'paste') {
      $timeout(function () {
        vm.addContact = angular.element($event.target).val();
      });
    } else {
      vm.addContact = (d.search && d.search != "") ? d.search : d.selected.name;
    }
  };

  vm.createMapping = function (mappingForm) {
    vm.responseReceived = false;
    let formData = {
      amazon_payout_mapping: {
        api_v1_contact_id: vm.payoutListForm.api_v1_contact.id,
        mapping: vm.payoutListForm.mapping,
        tax_type: vm.payoutListForm.tax_type.split(' ').join('_')
      }
    };
    if ($stateParams.id && $stateParams.mapping) {
      PayoutListService.editPayoutMapping(formData, vm.orgId, $stateParams.id, function (response) {
        vm.payoutListForm = {};
        if (response.status >= 200 && response.status < 300) {
          $state.go('user.organization.settingView.mapping.payout-mapping-list', { orgId: $stateParams.orgId }, { inherit: false });
          toaster.pop('info', response.data.message[0]);
          if (response.data.message[1]) toaster.pop('info', response.data.message[1]);
        } else {
          toaster.pop('error', CommonService.throwError(response));
        }
      });
    } else {
      PayoutListService.savePayoutMapping(formData, vm.orgId, function (response) {
        vm.responseReceived = true;
        vm.payoutListForm = {};
        mappingForm.$setPristine();
        mappingForm.$setUntouched();
        if (response.status >= 200 & response.status < 300) {
          toaster.pop('info', 'New Amazon Payout Mapping saved.');
          $state.go('user.organization.settingView.mapping.payout-mapping-list', { orgId: $stateParams.orgId }, { inherit: false });
        } else {
          toaster.pop('error', CommonService.throwError(response));
        }
      });
    }
  };

  vm.sortFlag = function (param) {
    var currentSort = $stateParams.sortBy;
    if (currentSort && currentSort.includes(param)) {
      if (!currentSort.includes('-')) {
        return false;
      }
    }
    return true;
  };

  vm.sort = function (param) {
    var currentSort = $stateParams.sortBy;
    if (currentSort && currentSort.includes(param)) {
      if (!currentSort.includes('-')) {
        param = '-' + param;
      }
    }
    $state.go('user.organization.settingView.mapping.payout-mapping-list', { sortBy: param });
  };

  vm.rowChange = function (param, pageSize) {
    vm.url = vm.mappingResponse.links[param];
    var arr = vm.url.split('?');
    vm.pageNumber = 1;
    vm.size = pageSize;
    vm.url = arr[0] + '.json?page=' + vm.pageNumber + '&size=' + vm.size;
    $state.go('user.organization.settingView.mapping.payout-mapping-list', { pageNumber: vm.pageNumber, size: vm.size });
  };

  vm.editMapping = function (mapping) {
    $state.go('user.organization.settingView.mapping.payoutNewMapping', { orgId: $stateParams.orgId, id: mapping.id, mapping: mapping }, { inherit: false });
  };

  vm.showDetails = function (id) {
    $state.go('user.organization.settingView.mapping.payout-mapping', { orgId: $stateParams.orgId, mappingId: id }, { inherit: false });
  };

  vm.search = function () {
    $state.go('user.organization.settingView.mapping.payout-mapping-list', { pageNumber: 1, size: vm.size, name: vm.searchParams.name });
  };

  vm.changePage = function (param) {
    vm.url = vm.mappingResponse.links[param];
    if (vm.url) {
      var arr = vm.url.split('?');
      vm.pageNumber = CommonService.getParameterByName('page', vm.url);
      vm.url = arr[0] + '.json?page=' + vm.pageNumber + '&size=' + vm.size;
      $state.go('user.organization.settingView.mapping.payout-mapping-list', { pageNumber: vm.pageNumber, size: vm.size });
    }
  };


  vm.deleteMapping = function (mappingId) {
    swal({
      title: "Are you sure?",
      text: "Do you want to delete this Amazon Payout Mapping?",
      icon: "warning",
      dangerMode: true,
      buttons: [true, true]
    })
      .then(willDelete => {
        if (willDelete) {
          PayoutListService.deletePayoutMapping($stateParams.orgId, mappingId, function (response) {
            vm.removePayoutMapping(mappingId);
            if (response.status == 204) {
              toaster.pop('info', 'Amazon Payout Mapping deleted.');
            } else {
              toaster.pop('error', CommonService.throwError(response));
            }
          });
        }
      });
  };

  vm.removePayoutMapping = function (mappingId) {
    for (var i = vm.mappingList.length - 1; i >= 0; i--) {
      if (vm.mappingList[i].id == mappingId) {
        vm.init();
      }
    }
  };
}

export default {
  name: 'PayoutMappingListCtrl',
  fn: PayoutMappingListCtrl
};
